import React, {useEffect} from 'react';
import {Container, Grid} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {setStep} from "../redux/actions/stepActions";
import {getTripById} from "../redux/actions/tripActions";
import TripHead from "../components/Booking/SelectRoom/TripHead";
import TripInfo from "../components/Booking/SelectRoom/TripInfo";
import InquiryForm from "../components/Booking/Information/InquiryForm";
import {isWidget, newRequestApi, registerFindTrip, requestLoader, showAlertAutoDis} from "../utils/utils";
import {useIsAuthenticated} from "react-auth-kit";
import GuestBar from "../components/GuestInfo/GuestBar";
import {TripPropTypes} from "../utils/PropTypes/TripPropTypes";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    mainContent: {
        paddingTop: 40
    }
}));

const initialData = {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    city: '',
    country: '',
    guests: '',
    inquiryType: '',
    interest: '',
    comments: ''
};

const InquiryPage = () => {
    const [inquiryData, setInquiryData] = React.useState(initialData);
    const classes = useStyles();
    const dispatch = useDispatch();
    const {id} = useParams();
    const {data: trip} = useSelector(state => state.trip);
    const rooms = useSelector(state => state.rooms);
    const isAuth = useIsAuthenticated();

    useEffect(() => {
        dispatch(setStep(1));
        dispatch(getTripById(id));
        registerFindTrip();
    }, []);

    const submitInquiry = async () => {
        const {TripId: tripId} = trip;
        await newRequestApi(`booking/inquiry-request/${tripId}`, 'POST',{...inquiryData, }, ({data}) => {
            if (data && 'title' in data && 'message' in data) {
                if ('status' in data && data['status'] === 'success')
                    setInquiryData(initialData);
                showAlertAutoDis({
                    title: `<span style="font-size:22px">${data.title}</span>`,
                    html: `<h5>${data.message}</h5>`
                });
            }
        });
        // showAlertAutoDis({
        //     title: 'Inquiry Form Submitted',
        //     text: 'We\'ve received your request, we\'ll get back to you as soon as possible'
        // });
    };

    const handleChange = (event) => {
        setInquiryData({...inquiryData, [event.target.name]: event.target.value});
    };

    return (
        <div>
            {isAuth() && <GuestBar/>}
            {trip && Object.keys(trip).length > 0 && <>
                <TripHead/>
                <Container maxWidth="lg" className={classes.mainContent}>
                    <TripInfo/>
                    <div style={{marginTop: 100}}/>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>
                            <InquiryForm setInquiry={handleChange} inquiryData={inquiryData}
                                         submitInquiry={submitInquiry} trip={trip} selectedRooms={rooms}/>
                        </Grid>
                    </Grid>
                </Container>
            </>}
        </div>
    );
};

export default InquiryPage;

InquiryPage.propTypes = {
    trip: TripPropTypes,
};